jQuery(document).ready(function ($) {

  setTimeout(function () {
    $('.prder_order_listing').eq(1).remove();
  }, 500)

  // Handle Read More click
  $(document).on('click', '.read-more', function (e) {
    e.preventDefault();

    var container = $(this).closest('.product-short-desc');
    var fullText = $('.product-full-desc').html();

    container.html(fullText);
  });


  if ($('body').hasClass('product_combo-product')) {
    
  } else if ($('body').hasClass('product_mattress-deepdream')) {
    $('.product__description').insertBefore($('#accordion_deepdream'));
    $('.product_payement_logo_new').insertAfter($('.discount_sale_bar_section'));

  }

  var $announcementBar = $('#shopify-section-announcement-bar');

  if ($announcementBar.length) {
    var offset = $announcementBar.offset().top;
    console.log('Offset:', offset);
  } else {
    console.log('#shopify-section-announcement-bar not found');
  }

  $(window).on('scroll', function () {
    if ($(window).scrollTop() > offset) {
      $announcementBar.addClass('stickyAncBar'); // Add sticky class
    } else {
      $announcementBar.removeClass('stickyAncBar'); // Remove sticky class
    }
  });


  $('.preorder_discout_bar').hide();


  /* TOOLTIP FUNCTION */

  setTimeout(function () {

    $('.pin-modal__content').each(function () {

      var price = $(this).find('.js-im-price').text().slice(1, $(this).find('.js-im-price').text().length - 3);
      price = price.replace(/,/g, '');
      console.log("EACH DISCOUNT", price);
      var discount = Math.round(price * 0.7);
      console.log("EACH DISCOUNT", discount);
      $(this).find('.pin-modal__price').prepend('<span class="js-disc-price"> $' + discount + '.00</span>')

    });

  }, 4000)

  setTimeout(function () {
    var buttonText = $('#product_detail_custom_add_to_cart span').text().trim();

    if (buttonText === "Pre-order Now") {
      $('.preorder_discout_bar').show();
      console.log("The button text is 'Pre-order Now'.");
      // Step 1: Extract the .delivery_detail HTML
      var deliveryDetailHtml = $('.post_check_main_grid .delivery_date').html();

      // Step 2: Update the preorder_discout_bar HTML
      $('.radio-est-arrival .delivery_date').html(deliveryDetailHtml);
      // Add any other actions you want to perform
    } else {

    }
  }, 4000)

  $('.mattress_products_grid_c').each(function (index) {
    $(this).find('.fration').text((index + 1) + '/4');
  });
  $('#shopify-section-template--14966969597994__mattress_product_grid_GxGQ8G .range-wrapper').remove();
  $('#shopify-section-template--14966969597994__mattress_product_grid_GxGQ8G .mattress_collection_product_grid_section').css({ 'padding': '0 0 40px' });
  //////////////////////////////////////////////////30%OFF//////////////////////////////////////////////////////

  
  ///////////////////////////////////////////////stickyHeader///////////////////////////////////////////////////
  $('body').on('click', '.search-open', function () {
    $('.menu-list-custom').toggleClass('search-open')
    $('.header_search').toggle();
    $('.open-svg').toggle();
    $('.close-svg').toggle();
  })
  var headerHeight = $('.header-wrapper').outerHeight() + 50;
  console.log("Height Header  " + headerHeight);
  var searchOpenAdded = false;
  // Function to add or remove class based on the scroll position
  function toggleClassBasedOnScroll() {
    if ($(window).scrollTop() >= 35 && !searchOpenAdded) {

      // if (document.querySelector('.dit-header-new') == null) {
      //   // window width 768
      //   if ($(window).width() <= 768) {
      //     $('main').attr('style', 'padding-top:119px!important;')
      //   } else {
      //     $('main').attr('style', 'padding-top:133.5px!important;')
      //   }
      // }
      $('.header-wrapper').addClass('scrolled');
      $('.header_search').hide();
      $('.opt-notifications_button').hide();
      $('.header__icon--account').hide();
      $('#heart-icon-bubble').hide();
      $('#cart-icon-bubble').before('<a href="javascript:void(0)" class="search-open"><div class="open-svg"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#2C474B"></rect><path d="M21.9983 22.1668L21.9975 22.1668C21.9756 22.1669 21.9538 22.1627 21.9336 22.1544C21.9135 22.1462 21.8952 22.1342 21.8797 22.1189L18.9989 19.2381C18.9768 19.2079 18.9655 19.171 18.9669 19.1334C18.9685 19.0914 18.9859 19.0516 19.0156 19.022C19.0453 18.9923 19.0851 18.9749 19.127 18.9733C19.1647 18.9718 19.2015 18.9832 19.2318 19.0052L22.1125 21.8859C22.1126 21.886 22.1127 21.8862 22.1128 21.8863C22.1436 21.9174 22.161 21.9596 22.161 22.0034C22.161 22.0469 22.144 22.0886 22.1137 22.1197C22.0828 22.1497 22.0415 22.1666 21.9983 22.1668Z" fill="black" stroke="white"></path><path d="M20.6471 15.3334C20.6471 16.3882 20.3343 17.4193 19.7483 18.2964C19.1623 19.1735 18.3293 19.8571 17.3548 20.2607C16.3802 20.6644 15.3079 20.77 14.2733 20.5642C13.2388 20.3584 12.2884 19.8505 11.5426 19.1046C10.7967 18.3587 10.2887 17.4084 10.0829 16.3739C9.87716 15.3393 9.98278 14.2669 10.3864 13.2924C10.7901 12.3179 11.4737 11.4849 12.3508 10.8989C13.2278 10.3128 14.259 10 15.3138 10C16.0159 9.9974 16.7115 10.1334 17.3609 10.4003C18.0103 10.6671 18.6006 11.0595 19.098 11.5551C19.5953 12.0506 19.99 12.6394 20.2593 13.2878C20.5285 13.9361 20.6671 14.6313 20.6671 15.3334H20.6471Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div><div class="close-svg" style="display: none;"><svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8532 22.9999C22.7008 23.0008 22.5497 22.9716 22.4086 22.914C22.2676 22.8564 22.1392 22.7715 22.0311 22.6641L16.9942 17.6274C16.8046 17.4059 16.7054 17.1209 16.7167 16.8295C16.7279 16.5381 16.8487 16.2617 17.055 16.0554C17.2612 15.8492 17.5376 15.7284 17.829 15.7172C18.1204 15.7059 18.4054 15.805 18.6269 15.9947L23.6637 21.0315C23.8793 21.2485 24.0004 21.542 24.0004 21.8479C24.0004 22.1537 23.8793 22.4472 23.6637 22.6641C23.448 22.8781 23.1569 22.9987 22.8532 22.9999Z" fill="#2C474B"></path><path d="M20.5028 10.2632C20.5028 12.0952 19.9595 13.8862 18.9417 15.4095C17.9238 16.9328 16.4771 18.1201 14.7845 18.8212C13.0919 19.5223 11.2294 19.7057 9.43252 19.3483C7.63565 18.9909 5.98513 18.1086 4.68966 16.8132C3.39419 15.5177 2.51197 13.8672 2.15455 12.0703C1.79714 10.2735 1.98058 8.41095 2.68168 6.71834C3.38278 5.02573 4.57005 3.57901 6.09336 2.56117C7.61667 1.54333 9.4076 1.00007 11.2397 1.00007C12.459 0.995492 13.6673 1.23173 14.7952 1.69519C15.923 2.15866 16.9483 2.84025 17.8121 3.70086C18.676 4.56148 19.3614 5.58416 19.8291 6.71028C20.2968 7.8364 20.5375 9.04379 20.5375 10.2632H20.5028Z" stroke="#2C474B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div></a>');

      // Update the variable to indicate that the element has been added
      searchOpenAdded = true;
    } else if ($(window).scrollTop() < 35 && searchOpenAdded) {
      var headerSearch = $('.header_search');
      // Check if the element is currently visible
      if (headerSearch.is(':visible')) {

        $('.menu-list-custom').toggleClass('search-open')
        $('.header_search').toggle();
        $('.open-svg').toggle();
        $('.close-svg').toggle();
      }
      
      $('.header-wrapper').removeClass('scrolled');
      $('.header_search').show();
      $('.opt-notifications_button').show();
      $('.header__icon--account').show();
      $('#heart-icon-bubble').show();
      $('.search-open').remove();

      // Update the variable to indicate that the element has been removed
      searchOpenAdded = false;
    }
  }
  $(document).on('click', function (event) {
    // Check if the click is outside the .search-open element
    if (!$(event.target).closest('.search-open').length && !$(event.target).closest('.header_search').length) {
      if ($('.header_search').length && $('.header_search').css('display') !== 'none') {
        // Clicked outside the .search-open
        console.log('Clicked outside .search-open');
        $('.close-svg').trigger('click')
        // Perform your desired action here
      }
    }
  });
  // Initial check
  toggleClassBasedOnScroll();

  // Listen for scroll event
  $(window).scroll(function () {
    toggleClassBasedOnScroll();
  });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $(document).on('mouseenter', ".bestseller_product", function (e) {
    $(this).find('.motion-reduce').hide();
    $(this).find('.second-hover-image').show();
  });
  $(document).on('mouseleave', ".bestseller_product", function (e) {
    $(this).find('.second-hover-image').hide();
    $(this).find('.motion-reduce').show();
  });
  

  $('.quantity-avl').each(function () {
    if ($(this).text().trim() === '') {
      $(this).hide();
    }
  });

  $('.dd-reviews-slider').slick({
    autoscroll: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('.product-sec-main .product-form__input.product-form__quantity quantity-input.quantity .qty-plus').on('click', function () {
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity;
    if (quantity != '' && quantity != 'undefined') {
      old_quantity = $('.product_custom_cart_qty').val();
      if (old_quantity !== false && typeof old_quantity !== 'undefined') {
        new_quantity = parseInt(old_quantity) + parseInt(1);
        $('.product_custom_cart_qty').val(new_quantity);
      }
    }
  })

  $('.product-sec-main .product-form__input.product-form__quantity quantity-input.quantity .qty-minus').on('click', function () {
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity;
    if (quantity != '' && quantity != 'undefined') {
      if ($(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val() > 1) {
        old_quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
        if (old_quantity != '' && old_quantity != 'undefined' && old_quantity > 0) {
          new_quantity = parseInt(old_quantity) - parseInt(1);
          $('.product_custom_cart_qty').val(new_quantity);
        }
      }
    }
  })

  // When a radio button in the "Size" fieldset is clicked
  $("fieldset.js.product-form__input input[name='Size']").click(function () {
    // Check if none is selected in the "Color" fieldset and set the first option if none is selected
    let colorFieldsetRadios = $("fieldset.js.product-form__input.color_option_field input[name='Color']");
    if (colorFieldsetRadios.filter(':checked').length === 0) {
      colorFieldsetRadios.first().prop('checked', true);
      var val = colorFieldsetRadios.first().val();
      jQuery('variant-radios .product-form__input input[name="Color"]:checked').closest('.product-form__input').find('legend.form__label').html('Color: <span class="color_slected">' + val + '</span>');
      colorFieldsetRadios.first().addClass('click7777777777');
    }
  });

  // When a radio button in the "Color" fieldset is clicked
  $("fieldset.js.product-form__input.color_option_field input[name='Color']").click(function () {
    // Check if none is selected in the "Size" fieldset and set the first option if none is selected
    let sizeFieldsetRadios = $("fieldset.js.product-form__input input[name='Size']");
    if (sizeFieldsetRadios.filter(':checked').length === 0) {
      sizeFieldsetRadios.first().prop('checked', true);
      sizeFieldsetRadios.first().trigger('click');
    }
  });
  ////////////////////////////// Recently viewd products popUp on click of overlay///////////////////////////////////////
  $(document).mouseup(function (e) {
    // Check if opt-notifications opt-shadow has the class active
    if ($('.opt-notifications.opt-shadow').hasClass('active')) {
      var container = $(".recent_view_product_inner");

      // Check if the target of the click is not the container or its descendants
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        console.log('Clicked outside .recent_view_product_inner');
        // Hide the popup
        $('.opt-notifications_button').trigger('click')
      }
    }
  });

  // Function to check if .quantity-avl span is blank
  function checkQuantityAvl() {
    if ($.trim($('.quantity-avl').text()) === '') {
      console.log('.quantity-avl span is blank');
      $('#ISR_button').hide();
    } else {
      $('#ISR_button').hide(); // Show the button if needed
      console.log('.quantity-avl span is not blank');
    }
  }

  // MutationObserver configuration
  const observerConfig = { childList: true, subtree: true };

  // Callback function to handle mutations
  const mutationCallback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check if .quantity-avl span is present after a mutation
        if ($('.quantity-avl').length > 0) {
          // Stop observing once the element is found
          observer.disconnect();
          // Check if .quantity-avl span is blank
          checkQuantityAvl();
        }
      }
    }
  };

  // Select the target node (parent of .quantity-avl span)
  const targetNode = document.querySelector('.dispatch_deatil');

  // Check if the target node exists before observing
  if (targetNode) {
    // Create a MutationObserver instance with the callback and configuration
    const observer = new MutationObserver(mutationCallback);

    // Start observing the target node for mutations
    observer.observe(targetNode, observerConfig);
  } else {
    console.log("Target node not found");
  }
  ////////////////////////////// Recently viewd products popUp on click of overlay///////////////////////////////////////
  // Check if the delivery_date contains 'Not Eligible'
  function updateDeliveryDate() {
    // Check if the delivery_date contains 'Not Eligible'
    var deliveryDateElement = document.querySelector('.delivery_date');
    if (deliveryDateElement && deliveryDateElement.textContent.trim() === 'Not Eligible') {
      // If 'Not Eligible', get the dispatch_date and add one day to it
      var dispatchDateElement = document.querySelector('.dispatch_date');
      if (dispatchDateElement) {
        var dispatchDate = new Date(dispatchDateElement.textContent.trim());

        // Add one day to the dispatch date
        dispatchDate.setDate(dispatchDate.getDate() + 1);

        // Format the new date as 'Day Month Year' (e.g., 14 December 2023)
        var day = dispatchDate.getDate();
        var month = dispatchDate.toLocaleString('default', { month: 'long' });
        var year = dispatchDate.getFullYear();

        // Construct the formatted date
        var formattedDate = day + ' ' + month + ' ' + year;

        // Update the delivery_date with the new date
        deliveryDateElement.textContent = formattedDate;
      }
    }
  }
  setTimeout(function () {
    // Check if the delivery_date contains 'Not Eligible'
    updateDeliveryDate();
  }, 5000)


})


function variantChange(obj) {
  var discountPercentage = $("input[name='bundle_product']").val();

  // List of SKUs eligible for 60% discount
  const skuList50 = [
    "LARA-CT-ABR", "AVRY-FLAMP", "WILY-ED160-BLK", "AMBR-DC-BLK", "CPA-V3-TV180-WOK",
    "MRN-FLAMP", "TATE-TV-NATURAL", "TATE-TV200-NATURAL", "TATE-TV200-BLACK",
    "TATE-ED120-OAK-WHT", "TATE-CT120-OAK", "TATE-D120-OAK", "TATE-SB-NATURAL",
    "FB-RCL41-LGF", "EZRA-CT100-WHT", "ARLO-TV160-WHT", "JOSIE-SB160-OAK",
    "DRIS-SB160-WNT", "RILY-SB-160", "TATE-CD160-OAK", "BLC-CT-BLK", "SRT-BT-WHT",
    "SRT-SB130-WHT", "BRDY-SOFA-LGY", "DUET-BH-Q", "ARH-5DC80-WHT", "CL-WB193-K-WNT",
    "FRA-RUG-160", "FRA-RUG-200", "ELNA-BF-Q", "ELNA-BF-K", "HAMY-BT-OAK", "DD-153Q5Z",
    "ALLY-4COD-WHT", "CRA-FLAMP", "TATE-ST-BLACK", "OWEN-FLAMP", "BRDY-SOFA-LEFT-LGY"
  ];

  var compareAtPrice = obj.compare_at_price;
  var price = obj.price;
  var originalPrice = obj.price;
  var collection_list = $('.product-sec-main').attr('data-collection');


  // Determine discount based on SKU
  let discount = 0;

  if (collection_list != '' && collection_list != 'undefined' && collection_list != null) {
    const collectionArray = collection_list.split(',').map(s => s.trim());
    if (collectionArray.includes('10% Collection') || collectionArray.includes('10%')) {
      discount = 10;
    } else if (collectionArray.includes('20% Collection') || collectionArray.includes('20%')) {
      discount = 20;
    } else if (collectionArray.includes('30% Collection') || collectionArray.includes('30%')) {
      discount = 30;
    } else {
      discount = skuList50.includes(obj.sku) ? 20 : 20;
    }
  }

  var price_with_disc = price - (price * discount / 100);
  var percentageDifferenceS = ((compareAtPrice - price_with_disc) / compareAtPrice) * 100;
  // alert(percentageDifferenceS)
  var showPercentage = Math.round(percentageDifferenceS); // adjusted logic

  jQuery('.sale-radio-badge').text(showPercentage + "% Off");
  jQuery('.mid-sale-discount-batches .total-saving-text').text("Save $" + Math.round((compareAtPrice - price_with_disc) / 100));

  var discountedPrice = (price_with_disc) / 100;
  var compPrice = compareAtPrice / 100;

  jQuery('.price-compare-new').text(window.shopcurrency + compPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));

  originalPrice = originalPrice / 100;
  jQuery('.originalPrice').text(window.shopcurrency + originalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));

  let $salePrice = $(this).find(".custom-price");


  // if (discount > 0) {
  let newPrice = originalPrice - (originalPrice * discount / 100);
  jQuery('.price-section .custom-price').text(window.shopcurrency + newPrice.toFixed(2));
  if (compPrice > originalPrice) {
    if ($('.fixed_discount_price').length > 0) {
      console.log('ComparePrice is here')
      let discountFixamount = compPrice - originalPrice;
      discountFixamount = parseFloat(discountFixamount.toFixed(2));
      $('.discount-percent').text(window.shopcurrency + discountFixamount.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      $('.mid-sale-discount-batches.one-column').removeClass('hide-bar');
      $('.discount_sale_bar_section.fixed_discount_price').removeClass('hide-bar');
    } else {
      console.log('ComparePrice is here')
      let discountPercentage = ((compPrice - originalPrice) / compPrice) * 100;
      console.log(discountPercentage)
      discountPercentage = Math.round(discountPercentage);
      $('.discount-percent').text(discountPercentage);
      $('.mid-sale-discount-batches.one-column').removeClass('hide-bar');
    }

    let price_discountPercentage = ((compPrice - originalPrice) / compPrice) * 100;
    price_discountPercentage = Math.round(price_discountPercentage);
    $('.price_discount_per span').text(price_discountPercentage);
    $('.price-compare-new').removeClass('hidden');
    if(price_discountPercentage < 10){
      $('.price_discount_per').addClass('hidden');
    } else {
      $('.price_discount_per').removeClass('hidden');
    }

  } else {
    $('.mid-sale-discount-batches.one-column').addClass('hide-bar');
    $('.discount_sale_bar_section.fixed_discount_price').addClass('hide-bar');
    $('.new_sale_banner_discount').text(' ');
    $('.price_discount_per, .price-compare-new').addClass('hidden');
  }


  let dollarSavings = (compPrice - newPrice).toFixed(2);
  jQuery('.mid-sale-discount-batches .total-saving-text').text("Save $" + dollarSavings);
  // ✅ Update Afterpay Price (1/4 of newPrice)
  let afterpaySplit = originalPrice / 4;
  jQuery('span.divided-after-pay').text(`$${afterpaySplit.toFixed(2)}`);
  // }

}


document.addEventListener('DOMContentLoaded', function () {

  const swiperEl = document.querySelector('.announcement-bar-slider');
  if (!swiperEl) return;
  const slides = swiperEl.querySelectorAll('.swiper-slide');

  // Load Swiper only if more than 1 slide
  if (slides.length > 1) {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      }
    });
  }

  const swiperEl2 = document.querySelector('.banner-text-sec-aa .collection-title-buttons-desktop .collection_title_buttons');
  const titles = swiperEl2?.querySelectorAll('.ctn-collectn-title') || [];
  const windowWidth = window.innerWidth;

  const swiperConfig = {
    slidesPerView: 2.5,
    spaceBetween: 10,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 3.5,
      },
      768: {
        slidesPerView: 4.5,
      },
      1024: {
        slidesPerView: 6.5,
      },
    },
  };

  if (swiperEl2 instanceof Element) {
    if (windowWidth <= 768 || titles.length > 6) {
      new Swiper(swiperEl2, swiperConfig);
    }
  }


  let mobileSwiper;

  function initMobileSwiper() {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768 && !mobileSwiper) {
      mobileSwiper = new Swiper('.collection-title-buttons-mobile .collection_title_buttons', {
        slidesPerView: 2.5,
        loop: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      });
    } else if (screenWidth > 800 && mobileSwiper) {
      mobileSwiper.destroy(true, true);
      mobileSwiper = undefined;
    }
  }

  window.addEventListener('load', initMobileSwiper);
  window.addEventListener('resize', initMobileSwiper);

  var shopBySlider = new Swiper('.shop-by-mob-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: '.shop-by-mob-slider .swiper-button-next',
      prevEl: '.shop-by-mob-slider .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 32,
      }
    }
  });

});
// 26 may

$(document).ready(function () {
  $(".collection_title_buttons .ctn-collectn-title ").click(function () {
    $(".collection_title_buttons .ctn-collectn-title").removeClass("active");
    $(this).addClass("active");
  });

  $(".collection_title_buttons a").click(function (e) {
    e.preventDefault();

    var sectionId = $(this).attr("href").substring(1).trim();


    if (sectionId === "all-style") {
      $(".contemt_collection_tab").show();
    } else {
      $(".contemt_collection_tab").hide(); // Hide all
      $("#" + sectionId).css("display", "block"); // Show the selected one
    }
  });

  if ($('.video-play-button').length > 0) {
    $('.banner_video_col.banner_video').on('click', function (e) {
      if ($(e.target).is('video') || $(e.target).closest('video').length) {
        // return;
      }
      const current = $(this);
      const currentVideo = current.find('video')[0];
      $('.banner_video_col.banner_video').each(function () {
        if (this !== current[0]) {
          const otherVideo = $(this).find('video')[0];
          if (otherVideo) otherVideo.pause();
          $(this).removeClass('play-video');
          $(this).find('.video-play-button').removeClass('hidden');
        }
      });

      if (current.hasClass('play-video')) {
        current.removeClass('play-video');
        current.find('.video-play-button').removeClass('hidden');
        if (currentVideo) currentVideo.pause();
      } else {
        current.addClass('play-video');
        current.find('.video-play-button').addClass('hidden');
        current.addClass('show-video');
        if (currentVideo) {
          currentVideo.play();
          // $(currentVideo).prop('muted', false);
        }
      }
    });
  }

  if ($('.pdp-accordian-block').length > 0) {
    $('.pdp-accordian-block .pdp-accordian-title').on('click', function () {
      $(this).parent('.pdp-accordian-block').siblings('.pdp-accordian-block').removeClass('active');
      $(this).parent('.pdp-accordian-block').siblings('.pdp-accordian-block').find('.pdp-accordian-content').slideUp();

      $(this).parent('.pdp-accordian-block').toggleClass('active');
      $(this).next('.pdp-accordian-content').slideToggle();
    });
  }

  if ($('.banner_video_cols').length > 0 && window.innerWidth < 750) {
    var banner_video_cols = new Swiper(".banner_video_cols", {
      slidesPerView: 'auto',
      spaceBetween: 6,
      mousewheel: {
          forceToAxis: true
      },
      navigation: {
        nextEl: '.banner_video_cols .swiper-button-next',
        prevEl: '.banner_video_cols .swiper-button-prev',
      },
      pagination: {
        el: ".banner_video_cols .swiper-pagination",
            clickable: true,
      },
    });
  }

  $('body').on('click', '#cart-drawer-product-popup-close', function (e) {
    e.preventDefault();
    $(this).parents('#cart-drawer-product-popup').removeClass('open-popup');
  });
  $('body').on('click', '.cart-drawer-product-atc.has-popup', function (e) {
    e.preventDefault();
    var id = $(this).attr('id');
    $('[data-popup="' + id + '"]').addClass('open-popup');
  });
  function varaintSelect(form, _this) {
    var url = form.attr('data-url');
    var getVariantData = JSON.parse(form.find('[type="application/json"]').text());
    var fieldsets = form.find('.prd-variant select').toArray();
    var options = [];

    $.each(fieldsets, function (i, v) {
      var value = $(v).val();
      options.push(value);
    });

    var currentVariant;

    $.each(getVariantData, function (i, variant) {
      var lll = 0;
      $.each(variant.options, function (index, option) {
        if (options[index] !== option) {
          lll = 1;
        }
      });
      if (lll == 0) {
        currentVariant = variant;
      }
    });

    if (!currentVariant) {
      form.find('.product-form__submit').attr('disabled', true);
      form.find('.product-form__submit span').html(window.variantStrings.unavailable);
    } else {
      $.get(url + '?variant=' + currentVariant.id + '&view=cart-reco-popup', function (data) {
        form.html($(data).html())
      });
    }
  }
  $('body').on('change', '.prd-variant select', function (e) {
    var form = $(this).closest('.cart-drawer-product-popup');
    varaintSelect(form);
  });


  if ($("#product-sticky-cart").length > 0) {
    $(window).scroll(function () {
      
      var btn_pos = 0;
      var footer_pos_top = 0;

      /* Button Position */
      if ($(".product-sec-main .product__info-wrapper product-form").length) {
          btn_pos = $(".product-sec-main .product__info-wrapper product-form").offset().top;

      } else if ($(".full_banner").length) {
          btn_pos = $(".full_banner").offset().top;
      }

      if ($("#secret-sofa-footer").length) {
        footer_pos_top = $("#secret-sofa-footer").offset().top;

      } else if ($("#shopify-section-footer").length) {
        footer_pos_top = $("#shopify-section-footer").offset().top;  
      } else if ($(".shopify-section-group-footer-group").length) {
        footer_pos_top = $(".shopify-section-group-footer-group").offset().top;  
      }

      var viewporttop = $(this).scrollTop();
      var viewportbottom = $(window).height() + $(this).scrollTop();

      if (viewporttop > btn_pos && viewportbottom < footer_pos_top) {
        $("#product-sticky-cart").fadeIn(500);
      } else {
        $("#product-sticky-cart").fadeOut(500);
      }
    });
  }

  if ($('.shop-the-look').length > 0) {
    var banner_video_cols = new Swiper(".shop-the-look .shop-the-look-slider", {
      slidesPerView: 2.1,
      loop: true,
      spaceBetween: 6,
      centeredSlides: false,
      loopedSlides: 6,
      loopedSlidesLimit: false,
      loopFillGroupWithBlank: true,
      pagination: {
        el: ".shop-the-look .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        750: {
          spaceBetween: 12,
          slidesPerView: 3.4,
          centeredSlides: false,
        },
        990: {
          spaceBetween: 18,
          slidesPerView: 4.5,
          centeredSlides: false,
        },
        1401: {
          spaceBetween: 18,
          slidesPerView: 6.5,
          centeredSlides: false,
        }
      }
    });

    window.addEventListener('load', () => {
      banner_video_cols.update();
    });
  }


  if ($('.stock-with-ship').length > 0) {
    $('body').on('click', '.stock-with-ship .stock-with-ship-toggle', function (e) {
      $(this).parent('.stock-with-ship').toggleClass('active');
      $(this).next('.stock-with-ship-info').slideToggle();
    });
  }

  if($('.pdp-dimension-blocks').length > 0){
    $('.pdp-dimension-blocks .pdp-dimension-toggle').click(function(){
      $(this).addClass('active').siblings('.pdp-dimension-toggle').removeClass('active');
      var dimension = $(this).data('pdp-dimension-id');
      $(this).parents('.pdp-dimension-blocks').find('.pdp-dimension-block[data-pdp-dimension-block="'+ dimension +'"]').removeClass('hidden').siblings('.pdp-dimension-block').addClass('hidden');
      $(this).parents('.pdp-accordian-content').find('.pdp-dimension-block-info[data-pdp-dimension-block-info="'+ dimension +'"]').removeClass('hidden').siblings('.pdp-dimension-block-info').addClass('hidden');
    });
  }

  if($('#pre-order_share-popup').length > 0){
    // Open registration pop-up
    $('.pre-order_share').on('click', function(e) {
      e.preventDefault();
      $('#pre-order_share-popup').show();
      $('body').addClass('overflow-hidden');
    });
    
      // Close pop-ups when clicking outside of the pop-up content
    $(window).on('click', function(event) {
      if ($(event.target).hasClass('pre-order_popup')) {
        $('#pre-order_share-popup').hide();
        $('body').removeClass('overflow-hidden');
      }
    });
  }

  if($('#pre-order_reward-popup').length > 0){
    // Open registration pop-up
    $('.share_reward_tiers a').on('click', function(e) {
      e.preventDefault();
      $('#pre-order_reward-popup').show();
      $('body').addClass('overflow-hidden');
    });
    
      // Close pop-ups when clicking outside of the pop-up content
    $(window).on('click', function(event) {
      if ($(event.target).hasClass('pre-order_reward_popup')) {
        $('#pre-order_reward-popup').hide();
        $('body').removeClass('overflow-hidden');
      }
    });
  } 


  if ($("#secret-sofa-sticky-bar").length > 0) {
    $(window).scroll(function () {
      var offest = 100;
      var footer_pos_top = $("#secret-sofa-footer").offset().top;
      var viewporttop = $(this).scrollTop();
      var viewportbottom = $(window).height() + $(this).scrollTop();
      if (viewporttop > offest && viewportbottom < footer_pos_top) {
        $("#secret-sofa-sticky-bar").fadeIn(500);
      } else {
        $("#secret-sofa-sticky-bar").fadeOut(500);
      }
    });
  }

  if ($(".mobile_country_list").length > 0) {
    $('body').on('click', '.mobile_country_list .main_country_flag_icon', function (e) {
      $(this).closest('.mobile_country_list').toggleClass('active');
      $(this).closest('#menu-drawer').toggleClass('active');
    });

     $(document).on('click', function (e) {
      if (!$(e.target).closest('.mobile_country_list').length) {
        $(".mobile_country_list").removeClass('active');
        $("#menu-drawer").removeClass('active');
      }
    });
  } 

  // __________Built to elevate
   if($('.built-to-elevate').length > 0 && $(window).width() < 992){
        var built_elevate_blocks = new Swiper('.built-to-elevate .built-to-elevate-block-row', {
            slidesPerView: 1.15,
            spaceBetween: 15,
            centeredSlides: true,
            loop: true,
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: '.built-to-elevate-block-row .swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                    centeredSlides: true,
                },
                992: {
                    slidesPerView: 'auto',
                    spaceBetween: 25,
                    centeredSlides: false,
                }
            }
        });
    }
    // __________Built to elevate

    // __________Faq Block JS
    if($('.new_faq').length > 0){
      $(".new_faq").each(function () {
        const $group = $(this);

        $group.find(".faq_head").on("click", function (e) {
          e.preventDefault();

          const $thisItem = $(this).closest(".faq_content_cols");
          const isActive = $thisItem.hasClass("active");

          // Close all tabs in this FAQ group
          $group.find(".faq_content_cols").removeClass("active");
          $group.find(".faq_content").slideUp(300);

          // If not already active, open it
          if (!isActive) {
            $thisItem.addClass("active");
            $thisItem.find(".faq_content").slideDown(300);
          }
        });
      });
    }
    // __________Faq Block JS

    // __________Audio Block
    if($('[data-audio-button]').length > 0){
    $('[data-audio-button]').on('click', function () {
      const $btn = $(this);
      const $player = $btn.closest('[data-audio-player]');
      const audio = $player.find('[data-audio]').get(0);

      $('[data-audio-player]').not($player).each(function () {
        const otherAudio = $(this).find('[data-audio]').get(0);
        const otherBtn = $(this).find('[data-audio-button]');
        const otherTxt = otherBtn.find('.btn-txt');

        otherAudio.pause();
        otherAudio.currentTime = 0;
        otherBtn.removeClass('is-playing');
      });

      if (audio.paused) {
        audio.play();
        $btn.addClass('is-playing');
      } else {
        audio.pause();
        $btn.removeClass('is-playing');
      }

      audio.onended = function () {
        $btn.removeClass('is-playing');
      };
    });
  }
    // __________Audio Block


    // __________Popup Modal
    if($('[data-popup-modal-wrap]').length > 0){
      function openPopup(popupWrap) {
        const popup = popupWrap.find('[data-popup-modal-block]');
        const videos = popup.find('video');

        popup.fadeIn(200);
        $('body').addClass('popup-open');

        videos.each(function () {
          this.pause();
          this.currentTime = 0;
          this.load(); 
        });
      }

      function closePopup(popupWrap) {
        const popup = popupWrap.find('[data-popup-modal-block]');
        const videos = popup.find('video');

        popup.fadeOut(200);
        $('body').removeClass('popup-open');

        videos.each(function () {
          this.pause();
          this.currentTime = 0;
        });
      }

      $(document).on('click', '[data-popup-modal-button]', function () {
        const popupWrap = $(this).closest('[data-popup-modal-wrap]');
        openPopup(popupWrap);
      });

      $(document).on('click', '[data-popup-modal-close]', function () {
        const popupWrap = $(this).closest('[data-popup-modal-wrap]');
        closePopup(popupWrap);
      });
    }
    // __________Popup Modal


     // __________Sleep Comparison

    if($('.sleep-comparsion .sleep-comparsion-row-wrap').length > 0 && $(window).width() < 750){
        var sleep_compare = new Swiper('.sleep-comparsion .sleep-comparsion-row-wrap', {
            slidesPerView: 'auto',
            freeMode: true,
            scrollbar: {
              el: '.sleep-comparsion .sleep-comparsion-row-wrap .swiper-scrollbar',
              draggable: true
            },
            mousewheel: {
              forceToAxis: true
            }
        });
    }

    // __________Sleep Comparison


    // __________Sleep Comparison
    if($('[data-preorder-popup-btn]').length > 0){
      $('body').on('click', '[data-preorder-popup-btn]', function () {
        const target = $(this).data('preorder-popup-target');
        const popup = $('[data-preorder-popup="' + target + '"]');
        popup.fadeIn();
      });
      $('body').on('click', '[data-preorder-popup-close],.preorder-popup--overlay', function () {
        $('[data-preorder-popup]').fadeOut();
      });
    }
    // __________Sleep Comparison

    // __________ Banners Slider
    if($('.banners-slider').length > 0){
      var banners_slider = new Swiper('.banners-slider .banners-slider-row',{
        slidesPerView: 'auto',
        spaceBetween: 12,
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: '.banners-slider .main_slider_button.next_btn',
          prevEl: '.banners-slider .main_slider_button.prev_btn',
        },
        breakpoints: {
          992: {
            spaceBetween: 18,
          }
        }
      });
    }
    // __________ Banners Slider

    // __________ discount code cart drawer
    $(document).on('click','.cart-discount__form-wrap .cart-discount-toggle-btn',function(){
      $(this).parents('.cart-discount-toggle').toggleClass('active');
      $(this).parents('.cart-discount-toggle').next('.cart-discount__form').slideToggle();
    });
    // __________ discount code cart drawer

});

document.addEventListener("DOMContentLoaded", function () {

  const lazyVideos = document.querySelectorAll("video.lazy-video");

  function loadVideo(video) {
    const source = video.querySelector("source");
    const videoUrl = video.getAttribute("data-video");
    const autoplay = video.getAttribute("data-autoplay") === "true";

    // check attribute instead of property
    if (!source.getAttribute("src")) {
      source.setAttribute("src", videoUrl);
      video.load();
    }

    if (autoplay) {
      video.setAttribute("autoplay", "");
      video.play().catch(function () {});
    }
  }

  function checkVisibility() {
    lazyVideos.forEach(function(video) {
      const rect = video.getBoundingClientRect();
      const visible = rect.top < window.innerHeight && rect.bottom > 0;

      if (visible) {
        loadVideo(video);
      }
    });
  }

  checkVisibility();
  window.addEventListener("scroll", checkVisibility, { passive: true });

});
/* caesar-batch5-title-breadcrumb-fix:start */
(function(){
  var fixes = [{"path": "/blogs/article/mattress-in-a-box-australia-guide", "displayTitle": "Mattress in a Box Australia: How to Choose Between Foam, Hybrid, and Natural Mattresses", "shortBreadcrumb": "Mattress in a Box Guide", "titleSelectors": [".article-template__title"]}];
  function normPath(p){ return (p || '').replace(/\/$/, ''); }
  function setText(el, value){ if(el && value && (el.textContent || '').trim() !== value) el.textContent = value; }
  function applyFix(){
    var path = normPath(window.location.pathname);
    fixes.forEach(function(fix){
      if(path !== normPath(fix.path)) return;
      document.querySelectorAll('.article-breadcrumb, .breadcrumbs, .breadcrumb, [aria-label="breadcrumbs"], [aria-label="breadcrumb"], [class*="breadcrumb"]').forEach(function(root){
        root.querySelectorAll('a[aria-current="page"], span[aria-current="page"], li:last-child a, li:last-child span, li:last-child').forEach(function(el){ setText(el, fix.shortBreadcrumb); });
      });
      (fix.titleSelectors || []).forEach(function(sel){ document.querySelectorAll(sel).forEach(function(el){ setText(el, fix.displayTitle); }); });
      var bodyTitle = document.querySelector('.blog-text.w-richtext > h1:first-of-type'); if(bodyTitle) bodyTitle.style.display = 'none';
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFix); else applyFix();
  setTimeout(applyFix,250); setTimeout(applyFix,1000); setTimeout(applyFix,2500);
})();
/* caesar-batch5-title-breadcrumb-fix:end */
